import {
    GET_ENTITIES_REQUEST,
    GET_ENTITIES_SUCCESS,
    GET_ENTITIES_FAILURE,
    GET_ENTITY_REQUEST,
    GET_ENTITY_SUCCESS,
    GET_ENTITY_FAILURE,
    CREATE_ENTITY_REQUEST,
    CREATE_ENTITY_SUCCESS,
    CREATE_ENTITY_FAILURE,
    UPDATE_ENTITY_REQUEST,
    UPDATE_ENTITY_SUCCESS,
    UPDATE_ENTITY_FAILURE,
    DELETE_ENTITY_REQUEST,
    DELETE_ENTITY_SUCCESS,
    DELETE_ENTITY_FAILURE,
    GET_ARTISTS_REQUEST,
    GET_ARTISTS_SUCCESS,
    GET_ARTISTS_FAILURE,
    GET_ENTITY_GLOBALS_REQUEST,
    GET_ENTITY_GLOBALS_SUCCESS,
    GET_ENTITY_GLOBALS_FAILURE,
    CLEAR_ENTITY_DATA,
} from '../actions/getEntity';

const initialState = {
    entities_loading: false,
    entities_error: null,
    entities_data: null,
    artists_loading: false,
    artists_error: null,
    artists_data: null,
    entity_loading: false,
    entity_error: null,
    entity_data: null,
    create_entity_loading: false,
    create_entity_error: null,
    create_entity_data: null,
    update_entity_loading: false,
    update_entity_error: null,
    update_entity_data: null,
    delete_entity_loading: false,
    delete_entity_error: null,
    delete_entity_data: null,
    entity_globals_loading: false,
    entity_globals_data: null,
    entity_globals_error: null,
};

export default function getEntityReducer(state = initialState, action) {
    switch (action.type) {
        case CLEAR_ENTITY_DATA:
            return {...state,
                entity_data: null,
                entity_error: null,
                create_entity_data: null, 
                create_entity_error: null,
                update_entity_data: null, 
                update_entity_error: null,
                delete_entity_data: null, 
                delete_entity_error: null,
            };
        case GET_ENTITIES_REQUEST:
            return { ...state, entities_loading: true, entities_data: null };
        case GET_ENTITIES_SUCCESS:
            console.log("GET_ENTITIES_SUCCESS => ", action.payload)
            return {
                ...state,
                entities_loading: false,
                entities_data:
                    action?.payload?.pagination?.page === 1
                        ? action?.payload?.data
                        : [
                            ...new Map([
                                ...(state?.games_data || []),
                                ...(action?.payload?.data || []),
                            ].map(item => [item._id, item])).values(),
                        ],
                entities_meta: {
                    total: action?.payload?.pagination?.total,
                    totalPages: action?.payload?.pagination?.totalPages,
                    currentPage: action?.payload?.pagination?.page,
                    limit: action?.payload?.pagination?.limit,
                },
            };
        case GET_ENTITIES_FAILURE:
            return { ...state, entities_loading: false, entities_error: action.payload };

        case GET_ARTISTS_REQUEST:
            return { ...state, artists_loading: true, artists_data: null };
        case GET_ARTISTS_SUCCESS:
            return { ...state, artists_loading: false, artists_data: action.payload };
        case GET_ARTISTS_FAILURE:
            return { ...state, artists_loading: false, artists_error: action.payload };

        case GET_ENTITY_GLOBALS_REQUEST:
            return { ...state, entity_globals_loading: true, entity_globals_data: null };
        case GET_ENTITY_GLOBALS_SUCCESS:
            return { ...state, entity_globals_loading: false, entity_globals_data: action.payload };
        case GET_ENTITY_GLOBALS_FAILURE:
            return { ...state, entity_globals_loading: false, entity_globals_error: action.payload };

        case GET_ENTITY_REQUEST:
            return { ...state, entity_error: true, entity_data: null };
        case GET_ENTITY_SUCCESS:
            return { ...state, entity_error: false, entity_data: action.payload };
        case GET_ENTITY_FAILURE:
            return { ...state, entity_error: false, entity_error: action.payload };

        case CREATE_ENTITY_REQUEST:
            return { ...state, create_entity_loading: true, create_entity_data: null };
        case CREATE_ENTITY_SUCCESS:
            return { ...state, create_entity_loading: false, create_entity_data: action.payload };
        case CREATE_ENTITY_FAILURE:
            return { ...state, create_entity_loading: false, create_entity_error: action.payload };

        case UPDATE_ENTITY_REQUEST:
            return { ...state, update_entity_loading: true, update_entity_data: null };
        case UPDATE_ENTITY_SUCCESS:
            return { ...state, update_entity_loading: false, update_entity_data: action.payload };
        case UPDATE_ENTITY_FAILURE:
            return { ...state, update_entity_loading: false, update_entity_error: action.payload };

        case DELETE_ENTITY_REQUEST:
            return { ...state, delete_entity_loading: true, delete_entity_data: null };
        case DELETE_ENTITY_SUCCESS:
            return { ...state, delete_entity_loading: false, delete_entity_data: action.payload };
        case DELETE_ENTITY_FAILURE:
            return { ...state, delete_entity_loading: false, delete_entity_error: action.payload };

        default:
            return state;
    }
}